/**
 * Descope change-order rules shared by the change-order modal (submit/validity
 * gates) and the change-order service (forwarded-items filter), so the "every
 * descoped product must carry a non-zero quantity delta" rule lives in exactly
 * one place. Money-only edits — net changed while quantity is untouched — are
 * no longer a valid descope change.
 */

/** The minimal shape a descope line needs to be evaluated against the rules. */
export interface DescopeChangeCandidate {
  isRemoved?: boolean;
  quantity: number;
  originalQuantity: number;
  netAmount: number;
  originalNetAmount: number;
}

/**
 * A descope line is a real, submittable change only when the whole line is
 * removed or its quantity actually moves. Net-only edits are excluded.
 */
export function isValidDescopeChange(item: DescopeChangeCandidate): boolean {
  return item.isRemoved === true || item.quantity !== item.originalQuantity;
}

/**
 * A money-only descope edit: the net amount changed but the line is neither
 * removed nor carries a quantity delta. This is the case the rule forbids.
 */
export function isMoneyOnlyDescopeEdit(item: DescopeChangeCandidate): boolean {
  return !isValidDescopeChange(item) && item.netAmount !== item.originalNetAmount;
}
